export enum LocalstorageKeys {
  TranslatorLang = "lang",
}
